import { Record } from 'immutable';

const MatchingCandidateRecord = Record({
  'matchingCandidateId': null,
  'chain': null,
  'brand': null,
  'pid': null,
  'name': null,
  'address1': null,
  'address2': null,
  'address3': null,
  'city': null,
  'countryCode': null,
  'stateProvinceCode': null,
  'postalCode': null,
  'matchRate': null
});

export class MatchingCandidate extends MatchingCandidateRecord {
  matchingCandidateId: number;
  chain: string;
  brand: string;
  pid: string;
  name: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  countryCode: string;
  stateProvinceCode: string;
  postalCode: string;
  matchRate: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-candidate.ts